import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import BottomNavigation from "@material-ui/core/BottomNavigation";
import BottomNavigationAction from "@material-ui/core/BottomNavigationAction";
import NavigationIcon from "@material-ui/icons/Navigation";
import DirectionsBikeIcon from "@material-ui/icons/DirectionsBike";
import AboutIcon from "@material-ui/icons/Info";
import { grey } from "@material-ui/core/colors";
import { withRouter } from "react-router-dom";

const styles = theme => ({
  root: {
    borderTop: `1px solid ${grey[100]}`
  }
});

class NavBar extends React.Component {
  handleChange = (event, path) => {
    this.props.history.push(path);
    // this.setState({ path });
  };

  render() {
    const { classes } = this.props;
    const path = this.props.history.location.pathname;

    return (
      <div className={classes.root}>
        <BottomNavigation
          value={path}
          onChange={this.handleChange}
          showLabels
          className={classes.root}
        >
          <BottomNavigationAction
            label="Eigen route"
            value="/eigenroute"
            icon={<NavigationIcon />}
          />
          {/* <BottomNavigationAction
            label="Bestaande routes"
            value="routes"
            icon={<LocationOnIcon />}
          /> */}
          <BottomNavigationAction
            label="Ambassadeurs"
            value="/ambassadeurs"
            icon={<DirectionsBikeIcon />}
          />
          <BottomNavigationAction
            label="Over"
            value="/over"
            icon={<AboutIcon />}
          />
        </BottomNavigation>
      </div>
    );
  }
}

NavBar.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired
};

export default withRouter(withStyles(styles)(NavBar));



// WEBPACK FOOTER //
// ./src/components/NavBar.js